import {Entity} from 'app/core/main.entity';
import {
  SwitchCheckboxCollection,
  SwitchRadioCollection
} from 'app/entities/switchCollection.entity';
import {EntityCollection} from 'app/core/main.entityCollection';

export class FilterItem extends Entity {
  id: string;
  title: string;
  itemCollection: SwitchCheckboxCollection | SwitchRadioCollection;
}


export class FilterList extends EntityCollection<FilterItem> {

  constructor(items: FilterItem[]) {
    super(items, FilterItem);
  }

  getSelectedItems?() {
    const selectedData = {};

    this.items?.forEach(item => {
      selectedData[item.id] = item.itemCollection?.getSelectedId();
    });

    return selectedData;
  }

  makeCloneItems() {
    return {
      items: this.items.map(item => {
        const copy = {
          ...item,
          itemCollection: item.itemCollection.makeClone()
        };

        if (copy.itemCollection instanceof SwitchCheckboxCollection) {
          copy.itemCollection.convertSelectModalData();
        }
        return copy;
      })

    };
  }

  hasSelectedItems() {
    return !!this.items.find(item => item.itemCollection.hasSelected());
  }
}
